import {
  getFirestore,
  collection,
  query,
  where,
  onSnapshot,
} from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "../../config/config";
import { REF, REGION } from "../ref";
import { TYPES } from "./payout_daily.type";

const firestore = getFirestore(app);
const functions = getFunctions(app, REGION);

let payoutDailySub = null;

export const snapPayoutDaily =
  ({ startDate, endDate }) =>
  (dispatch) => {
    if (payoutDailySub) {
      payoutDailySub();
      payoutDailySub = null;
    }
    dispatch({ type: TYPES.GET_PAYOUT_DAILY_REQUEST });
    const q = query(
      collection(firestore, REF.PAYOUT_DAILY),
      where("date", ">=", startDate),
      where("date", "<=", endDate),
    );
    payoutDailySub = onSnapshot(q, (snapshot) => {
      const records = snapshot.docs.map((d) => d.data());
      dispatch({ type: TYPES.GET_PAYOUT_DAILY_SUCCESS, payload: records });
    });
  };

export const unSnapPayoutDaily = () => () => {
  if (payoutDailySub) {
    payoutDailySub();
    payoutDailySub = null;
  }
};

export const calculatePayoutDailyData = (callback) => () => {
  const calculateData = httpsCallable(
    functions,
    "api-payoutDaily-calculate-data",
  );
  calculateData({})
    .then((response) => {
      if (callback) {
        callback({
          status: 200,
          data: response?.data,
        });
      }
    })
    .catch((error) => {
      if (callback) {
        callback({
          status: 500,
          data: error?.message || "Please try again",
        });
      }
    });
};
